import App from './app';
import Timeline from './timeline/timeline';
import LiveJudging from './livejudging/livejudging';
import Case from './case/case';
import ProfilePage from './profile/profile';
import Profiles from './profiles/profiles';
import Editorial from './editorial/editorial';
import Page from './page/page';
import ErrorPage from './errorPage/errorPage';
import Jobs from './jobs/jobs';
import News from './news/news';
import NewsSingle from './newsSingle/newsSingle';
import JobPage from './job/job';
import Jury from './jury/jury';

import Account from './account/account';
import AccountLogin from './account/login';
import AccountRegister from './account/register';
import AccountActivate from './account/activate';
import AccountLogout from './account/logout';
import AccountRecover from './account/recover';

import AccountBasic from '../components/account/basic';
import AccountJury from '../components/account/jury';
import AccountJuryFOTD from '../components/account/jury/fotd';
import AccountJuryFOTM from '../components/account/jury/fotm';
import AccountJuryFOTY from '../components/account/jury/foty';
import AccountJuryTCEA from '../components/account/jury/tcea';

import ProfileEditorial from '../components/account/editorialList';
import EditorialEdit from '../components/account/editorialEdit';
import ProfileEdit from '../components/account/profileEdit';
import CaseList from '../components/account/caseList';
import CaseCreate from '../components/account/caseCreate';
import CaseEdit from '../components/account/caseEdit';
import AdminJuryOverview from '../components/account/juryOverview';

import JobList from '../components/account/jobList';
import JobCreate from '../components/account/jobCreate';
import JobEdit from '../components/account/jobEdit';

import SubmitCaseNotLoggedIn from '../components/submit/caseSubmit';
import SubmitJobNotLoggedIn from '../components/submit/jobSubmit';

import TCEAYVote from './publicvoting/tceay';
import PCAVote from './publicvoting/pca';

export default {
	App: App,
	Timeline: Timeline,
	LiveJudging: LiveJudging,
	Case: Case,
	ProfilePage: ProfilePage,
	Profiles: Profiles,
	Editorial: Editorial,
	Page: Page,
	ErrorPage: ErrorPage,
	Jobs: Jobs,
	News: News,
	NewsSingle: NewsSingle,
	JobPage: JobPage,
	Jury: Jury,

	Account: Account,
	AccountLogin: AccountLogin,
	AccountRegister: AccountRegister,
	AccountActivate: AccountActivate,
	AccountLogout: AccountLogout,
	AccountRecover: AccountRecover,

	SubmitCaseNotLoggedIn: SubmitCaseNotLoggedIn,
	SubmitJobNotLoggedIn: SubmitJobNotLoggedIn,

	TCEAYVote: TCEAYVote,
	PCAVote: PCAVote,
};

export let accountPages = {
	AccountBasic: AccountBasic,
	AccountJury: AccountJury,
	AccountJuryFOTD: AccountJuryFOTD,
	AccountJuryFOTM: AccountJuryFOTM,
	AccountJuryFOTY: AccountJuryFOTY,
	AccountJuryTCEA: AccountJuryTCEA,

	//AccountEditorial: AccountEditorial,
	ProfileEdit: ProfileEdit,

	ProfileEditorial: ProfileEditorial,
	EditorialEdit: EditorialEdit,

	CaseList: CaseList,
	CaseCreate: CaseCreate,
	CaseEdit: CaseEdit,

	JobList: JobList,
	JobCreate: JobCreate,
	JobEdit: JobEdit,

	AdminJuryOverview: AdminJuryOverview,
};



/** WEBPACK FOOTER **
 ** ./frontend/containers/containers.js
 **/